import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { PageLayout } from '@/components/layout/PageLayout'
import { useTranslation } from 'react-i18next'
import './i18n'

function App() {
  const { i18n } = useTranslation();
  const { hash, pathname } = useLocation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let attempts = 0;
      const maxAttempts = 20; // 2 seconds total

      const scrollToElement = () => {
        const element = document.getElementById(id);
        if (element) {
          // Check if element has height or wait if it's still 0 (loading content)
          const rect = element.getBoundingClientRect();
          if (rect.height > 0 || attempts >= maxAttempts) {
            element.scrollIntoView({ behavior: 'smooth' });
            return;
          }
        }

        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(scrollToElement, 100);
        }
      };

      scrollToElement();
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash, pathname]);

  return (
    <PageLayout>
      <Outlet />
    </PageLayout>
  )
}

export default App
